import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link, useHistory } from "react-router-dom";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import Select, { AriaOnFocus } from "react-select";
import AsyncSelect from "react-select/async";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  getPartyApi,
  getFillerStockList,
  getMainStockInward,
  getUserByRoleId,
  getFillerInwardStock,
  getFillerStock,
  getUserApi,
} from "api";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";

class FillerStockList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      status: "",
      partyId: "",
      factoryId: "",
      orderId: "",
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      orderList: [],
      stockList: [],
      partyList: [],
      inwardId: "",
      fillerList: [],
      jangadId: "",
      graderList: [],
      graderUserId: "",
    };
  }

  async componentDidMount() {
    const grader = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      roleId: "ROLE0000002",
    });

    if (grader && grader.data && Array.isArray(grader.data.users)) {
      this.setState({ graderList: grader.data.users });
    }
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }

    const jangadList = await getFillerStockList({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    if (jangadList && jangadList.data) {
      this.setState(
        {
          orderList: jangadList.data.fillerStocks,
        },
        () => console.log(this.state.fillerStocks)
      );
    }

    this.getStockList();
  }

  async getStockList() {
    const stock = await getFillerStockList({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      graderUserId: this.state.graderUserId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });
    if (stock && stock.data) {
      this.setState({
        totalSize: stock.data.count,
        stockList: stock.data.fillerStocks,
      });
    }
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    this.setState({
      partyList: data.data.parties,
    });
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.partyCode, value: x.id };
        }),
      ];
    else return [];
  }
  async getJangadList(inputValue) {
    const data = await getFillerStockList({
      page: 1,
      limit: 10,
      partyId: this.state.partyId,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      orderId: this.state.orderId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      name: inputValue,
    });
    if (data && data.data) {
      this.setState({
        orderList: data.data.fillerStocks,
      });
    }

    if (Array.isArray(data.data.fillerStocks))
      return [
        { label: "All", value: "" },
        ...data.data.fillerStocks.map(x => {
          return { label: x.mainJangad.name, value: x.mainJangad.id };
        }),
      ];
    else return [];
  }
  async getGraderList(inputValue) {
    const data = await getUserApi({
      page: null,
      limit: null,
      factoryId: JSON.parse(localStorage.getItem("authUser")).factoryId,
      name: inputValue,
      roleId: "ROLE0000002",
    });
    this.setState({
      graderList: data.data.users,
    });
    if (Array.isArray(data.data.users))
      return [
        { label: "All", value: "" },
        ...data.data.users.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }
  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const promiseOptionsFiller = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getGraderList(inputValue));
        }, 0);
      });
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });

    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "graderName",
        text: `${this.props.t("Grader Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.graderStock?.user?.name;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Total Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ "margin-right": "5px" }}>{row.jangad.pieces}</div>
              <div className="text-success">({row?.stockFillerInWards?.length || 0})</div>
            </div>
          );
          // return row.stockFillerInWards.length;
        },
      },
      {
        dataField: "remainingPieces",
        text: `${this.props.t("Remaining Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let remainingPieces = 0;
          remainingPieces =  row.stockFillerInWards.filter((x) => x.cubeInformation == null).length 
          
          return remainingPieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.stockFillerInWards?.reduce((acc, item) => acc + item?.stockGraderInWard?.weight, 0).toFixed(2);
          {
            return (
              <div className="d-flex justify-content-start pe-3">
                <div style={{ "margin-right": "5px" }}>{row.jangad.weight}</div>
                <div className="text-success">({tot})</div>
              </div>
            );
          }
          // return row.jangad.weight;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          return (
            <>
              <Link
                to={{
                  pathname: "/filler-edit-verify-accept",
                  query: {
                    isEdit: 3,
                    data: row,
                  },
                }}
              >
                <button className="py-2 px-2 border-0 rounded me-2">
                  <img src="images/dashboard-images/view.svg" />
                </button>
              </Link>
            </>
          );
        },
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize,
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "filler flow";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.stockList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("My Stock List")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h4 className="text-black fw-bold">
                                  {this.props.t("My Stock List")}
                                </h4>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e =>
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                                <label
                                  htmlFor="date"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e =>
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    )
                                  }
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party Code")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.partyCode,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Grader Name")}
                                    </label>
                                    <AsyncSelect
                                      id="fillerId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            graderUserId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptionsFiller}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.graderList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              {/* <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Jangad No")}
                                    </label>
                                    <select
                                      id="inwardID"
                                      className="officestock-select"
                                      onChange={e => {
                                        this.setState({
                                          jangadId: e.target.value,
                                        });
                                      }}
                                    >
                                      <option value="">ALL</option>
                                      {this.state.stockList
                                        ?.filter(x =>
                                          x.mainJangad.partyId ==
                                            this.state.partyId ||
                                          this.state.partyId == ""
                                            ? true
                                            : false
                                        )
                                        .map((x, index) => (
                                          <option
                                            key={x.id + index}
                                            value={x.id}
                                          >
                                            {x.id}
                                          </option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                              </div> */}

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if (e.value == "") {
                                              this.getJangadList(null);
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            label: x.mainJangad.name,
                                            value: x.mainJangad.id,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    onTableChange={() => false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage * this.state.page}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(FillerStockList);
